import React, { useContext } from 'react';
import createPlatformRoute from './createPlatformRoute'
import CommissionAdminProvider from './context/CommissionAdminProvider'
import AuthProvider from './context/AuthProvider'
import AuthContext from './context/AuthContext'
import messages from './messages'
import translations from './translation'
import { PlatformApp } from '@platform/cj-platform-navigation'
import CommissionRequest from './containers/CommissionRequest'
import CommissionResult from './containers/CommissionResult'
import Home from './containers/Home'
import AlternatePayeeContainer from './containers/AlternatePayee'
import PayoutResults from './containers/PayoutResults'
import Loading from './components/Loading'
import Unauthorized from './components/403'
import { AuthValues } from './types'


const AuthorizedApp = () => {
  const { authorizationsState, authorizations, retryAuthorizations } = useContext<AuthValues>(AuthContext)

  if (authorizationsState === 'loading') {
    return <Loading animated data-testid="authz-loading" />
  }

  if (authorizationsState === 'unauthorized') {
    return <Unauthorized />
  }

  if (authorizationsState === 'error') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '4rem' }}>
        <p>Something went wrong loading your permissions. Please try again.</p>
        <button onClick={retryAuthorizations}>Retry</button>
      </div>
    )
  }

  const routes = [
    createPlatformRoute("/", messages.labelFintechAdminTools, Home, authorizations),
    createPlatformRoute("/alternate-payee", messages.labelFintechAdminTools, AlternatePayeeContainer, authorizations),
    createPlatformRoute("/commission-request", messages.labelCommissionRequest, CommissionRequest, authorizations),
    createPlatformRoute("/commission-result", messages.labelCommissionResponse, CommissionResult, authorizations),
    createPlatformRoute("/payout-results", messages.labelPayoutResults, PayoutResults, authorizations),
  ];

  return <PlatformApp routes={routes} translations={translations.translations} onIntlError={translations.onIntlError} />
}


const App = () => (
  <AuthProvider>
    <CommissionAdminProvider>
      <AuthorizedApp />
    </CommissionAdminProvider>
  </AuthProvider>
)

export default App;
